var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector200(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3813 0.814847L3.85625 3.31485C-1.20208 5.00651 -1.20208 7.76485 3.85625 9.44818L6.08958 10.1898L6.83125 12.4232C8.51458 17.4815 11.2813 17.4815 12.9646 12.4232L15.4729 4.90651C16.5896 1.53151 14.7563 -0.310153 11.3813 0.814847ZM11.6479 5.29818L8.48125 8.48151C8.35625 8.60651 8.19792 8.66485 8.03958 8.66485C7.88125 8.66485 7.72292 8.60651 7.59792 8.48151C7.35625 8.23985 7.35625 7.83985 7.59792 7.59818L10.7646 4.41485C11.0063 4.17318 11.4062 4.17318 11.6479 4.41485C11.8896 4.65651 11.8896 5.05651 11.6479 5.29818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector200);
export default __webpack_public_path__ + "static/media/Vector(200).49250e2d3ea3455615981dea7b03fcae.svg";
export { ForwardRef as ReactComponent };